module.exports = "<app-loading></app-loading>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth-check/auth-check.component.html
// module id = ./src/app/auth/auth-check/auth-check.component.html
// module chunks = main